const LABELS = {
  invoice: "Invoice",
  "consumer invoice": "Consumer Invoice",
  receipt: "Receipt",
};

function getInvoiceLabel(value) {
  return LABELS[String(value || "invoice").toLowerCase()] || LABELS.invoice;
}

function formatLabelByCase(label, sample) {
  if (!sample) {
    return label;
  }

  if (sample === sample.toUpperCase()) {
    return label.toUpperCase();
  }

  if (sample[0] === sample[0].toUpperCase()) {
    return label;
  }

  return label.toLowerCase();
}

export function invoicePrintLabel(setting, sample = "Invoice") {
  const label = getInvoiceLabel(setting?.metadata?.invoicePrintLabel);
  return formatLabelByCase(label, sample);
}

export function replaceInvoiceLabel(text, setting) {
  const label = getInvoiceLabel(setting?.metadata?.invoicePrintLabel);

  return String(text).replace(/invoice/gi, (match) => {
    return formatLabelByCase(label, match);
  });
}
